import { apiSlice } from '@/store/api/apiSlice';

interface PlanetVakriItem {
  progressiveTime: string;
  retrogradeTime: string;
  totalRetrograde: string;
}

export interface PlanetVakriResponse {
  planetName: string;
  vakri: PlanetVakriItem[];
}

export const planetVakriTransitApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetVakriTransit: builder.query<PlanetVakriResponse[], void>({
      query: () => ({
        url: '/transits/planet-vakri',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPlanetVakriTransitQuery } = planetVakriTransitApi;
